import cep from "cep-promise";

const providers = ["brasilapi", "viacep"];
export class CEPService {
  async buscarDadosDoCep(cepString) {
    try {
      const cepFormatado = this.formatarCep(cepString);
      if (!cepFormatado) {
        throw new Error("CEP inválido");
      }

      const response = await cep(cepFormatado, { providers });

      return {
        cep: response.cep,
        cidade: response.city,
        estado: response.state,
        rua: response.street,
        bairro: response.neighborhood,
      };
    } catch (error) {
      throw new Error("Não foi possível buscar as informações do CEP");
    }
  }

  getCepInteiro(cepValue) {
    // "99999-999" => 99999999
    if (!cepValue) return null;
    const strComNumeros = `${cepValue}`.replace(/\D/g, "");
    if (strComNumeros.length !== 8) return null;
    return parseInt(strComNumeros, 10);
  }

  formatarCep(cepValue) {
    if (!cepValue) return null;
    const strComNumeros = `${cepValue}`.replace(/\D/g, "");
    if (strComNumeros.length !== 8) return null;
    return `${strComNumeros.substring(0, 5)}-${strComNumeros.substring(5)}`;
  }

  validarCep(cepValue) {
    if (!cepValue) return false;
    const strComNumeros = `${cepValue}`.replace(/\D/g, "");
    return strComNumeros.length === 8;
  }
}

export default new CEPService();
